const mutations = {
  setEmployeeRoleDefinitions(state, roles) {
    state.employeeRoleDefinitions = roles || [];
  },
};

export default mutations;
